exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pallet-teaser[data-v-e33e819a] {\n  cursor: pointer;\n}\n.pallet-teaser h5[data-v-e33e819a] {\n    color: var(--q-color-primary);\n}\n", ""]);

